<template>
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="row">
                <div class="col-sm-6 mb-2">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Подобрать картину</h5>
                            <p class="card-text">Посмотрите как будет выглядеть ваша картина.
                                Вы сможете подобрать фотографию и выбрать цветовую палитру набора.</p>
                            <router-link to="/demo" class="btn btn-primary">Попробовать</router-link>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 mb-2">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Получить инструкцию</h5>
                            <p class="card-text">У вас уже есть набор и вы хотите получить инструкцию для своей картины
                                ?
                                Скорее переходите по ссылке и начинайте творить.</p>
                            <router-link to="/qr_code" class="btn btn-primary">Ввести код</router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mb-2">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Наши советы</h5>
                            <p class="card-text">Как выбрать фотографию ? Как удобней рисовать картину ?
                                Ответы на эти и другие вопросы вы найдете в нашем разделе.</p>
                            <router-link to="/faq" class="btn btn-primary">Советы</router-link>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 mb-2">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">PIXSMART</h5>
                            <p class="card-text">Если у вас появились вопросы или предложения свяжитесь с нами. Мы
                                рассматриваем все
                                письма поступающие на почту.</p>
                            <router-link to="/contacts" class="btn btn-primary">О нас</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IndexN"
    }
</script>

<style scoped>

</style>